// extracted by css-extract-rspack-plugin
export default {"current-value-label":"fkY2KS","currentValueLabel":"fkY2KS"};